import { ExpandMore } from '@mui/icons-material';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Chip,
    Grid,
    Link,
    Typography,
} from '@mui/material';
import './PlagiarismAccordions.css';

const PlagiarismAccordions = ({ results }) => {
    // console.log('plagiarism results:', results);

    // Transform Originality.ai data structure to match component expectations
    const transformData = (originalResults) => {
        if (!originalResults?.results) return { phraseResults: [], websiteResults: [] };

        const phraseResults = originalResults.results.map((item) => ({
            phrase: item.phrase,
            matches: item.results.map((result) => ({
                score: result.scores?.[0]?.score * 100 || 0, // Convert to percentage
                website: result.link,
                title: result.title,
            })),
        }));

        return { phraseResults };
    };

    const { phraseResults } = transformData(results);

    return (
        <div className='PlagPanel__table'>
            <Grid item xs={12}>
                <Grid container paddingLeft={2} paddingRight={5} paddingY={2}>
                    <Grid item xs={12} md={8}>
                        <Typography sx={{ fontWeight: 500 }}>Plagiarized Phrase</Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Typography sx={{ fontWeight: 500, textAlign: 'center' }}>
                            Matched Websites
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Typography sx={{ fontWeight: 500, textAlign: 'center' }}>
                            Average Score
                        </Typography>
                    </Grid>
                </Grid>
                {phraseResults?.map((phraseItem, index) => {
                    const phrase = phraseItem.phrase;
                    const matches = phraseItem.matches;

                    // Calculate average score
                    const totalScore = matches.reduce((acc, curr) => acc + curr.score, 0);
                    const avgScore = matches.length > 0 ? totalScore / matches.length : 0;

                    return (
                        <Accordion key={index} elevation={0}>
                            <AccordionSummary
                                className='PlagPanel__table-row'
                                expandIcon={<ExpandMore />}
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                            >
                                <Grid container>
                                    <Grid item xs={12} md={8}>
                                        <Typography>"{phrase}"</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={2} sx={{ textAlign: 'center' }}>
                                        <Typography>{matches.length}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={2} sx={{ textAlign: 'center' }}>
                                        <Chip
                                            label={avgScore.toFixed(0) + '%'}
                                            color='error'
                                            variant='filled'
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails>
                                {matches.map((match, i) => {
                                    // Limit to 10 results
                                    if (i > 9) return null;

                                    let displayUrl = match.website
                                        .replace('https://', '')
                                        .replace('http://', '')
                                        .replace('www.', '');
                                    displayUrl =
                                        displayUrl.length > 50
                                            ? displayUrl.slice(0, 50) + '...'
                                            : displayUrl;

                                    return (
                                        <Box
                                            key={i}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                width: '100%',
                                                alignItems: 'center',
                                                gap: '1rem',
                                                marginBottom: '1rem',
                                            }}
                                        >
                                            <Chip
                                                label={match.score.toFixed(0) + '%'}
                                                color='error'
                                                variant='filled'
                                            />
                                            <Box>
                                                <Link
                                                    href={match.website}
                                                    target='_blank'
                                                    rel='noreferrer'
                                                >
                                                    {match.title || displayUrl}
                                                </Link>
                                            </Box>
                                        </Box>
                                    );
                                })}
                            </AccordionDetails>
                        </Accordion>
                    );
                })}

                {/* Show message if no plagiarism results */}
                {(!phraseResults || phraseResults.length === 0) && (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                        <Typography variant='body1' color='textSecondary'>
                            No plagiarism detected.
                        </Typography>
                    </Box>
                )}
            </Grid>
        </div>
    );
};

export default PlagiarismAccordions;
